import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleValidatedByProfessionalsUseCaseInterface } from 'domain/usecases';

interface IValidatedByProfessionalsState {
  validatedByProfessionals: HandleValidatedByProfessionalsUseCaseInterface.Result;
}

interface IPayloadValidatedByProfessionals
  extends PayloadAction<HandleValidatedByProfessionalsUseCaseInterface.Result> {}

const initialState: IValidatedByProfessionalsState = {
  validatedByProfessionals: null,
};

export const ValidatedByProfessionalsSlice = createSlice({
  name: 'validated-by-professionals',
  initialState,
  reducers: {
    loadValidatedByProfessionals: (
      state,
      action: IPayloadValidatedByProfessionals,
    ) => {
      state.validatedByProfessionals = action.payload;
    },
    clearValidatedByProfessionals: (state) => {
      state.validatedByProfessionals = null;
    },
  },
});

export const { loadValidatedByProfessionals, clearValidatedByProfessionals } =
  ValidatedByProfessionalsSlice.actions;

export default ValidatedByProfessionalsSlice.reducer;
